@if (data?.percentage) {
	<span
		[class]="getClass()"
		[appTooltip]="data.tooltip"
		[routerLink]="urlService.getRouterLink(data.selection)"
		[queryParams]="urlService.getSelectionQueryParams(data.selection)"
		[state]="{ doorklik: true }"
	>
		{{ data.percentage | extendedPercent: format }}
	</span>
} @else {
	<span
		[class]="getClass()"
		[appTooltip]="data?.tooltip"
		[routerLink]="urlService.getRouterLink(data?.selection)"
		[queryParams]="urlService.getSelectionQueryParams(data?.selection)"
		[state]="{ doorklik: true }"
	>
		{{ data?.ds_m_nr_weging | extendedDecimal: format }}
	</span>
}
